import { Injectable, OnDestroy } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject, Subscription, interval } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeploymentRefreshService {
  constructor(public swUpdate: SwUpdate) { }
  updateClient() {
    // console.log("SWUPDATE=",this.swUpdate);
    if (!this.swUpdate.isEnabled) {
      console.log('Not Enabled');
      return;
    }
    this.swUpdate.available.subscribe((event) => {
      // console.log('Current',event.current);
      // console.log('Available',event.available);
      if (confirm('A new version of the Web Portal is available. Please hard refresh your browser window or click on the "Ok" button to reload.')) {
        this.swUpdate.activateUpdate().then(() => location.reload());
      }
    });

    this.swUpdate.activated.subscribe((event) => {
      // console.log('Previous',event.previous);
      // console.log('Current',event.current);
    });
  }

}
